"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/auth/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'changePassword',
  data: function data() {
    return {
      disabled: false,
      data: {
        oldPassword: null,
        newPassword: null,
        newPassword2: null
      }
    };
  },
  created: function created() {},
  methods: {
    submit: function submit() {
      var _this = this;
      this.disabled = true;
      if (!this.data.oldPassword) {
        this.$message.warning({
          message: "请输入旧密码"
        });
        this.disabled = false;
        return;
      }
      if (!this.data.newPassword) {
        this.$message.warning({
          message: "请输入新密码"
        });
        this.disabled = false;
        return;
      }
      if (!this.data.newPassword2) {
        this.$message.warning({
          message: "请确认新密码"
        });
        this.disabled = false;
        return;
      }
      (0, _user.changePass)(this.data).then(function (res) {
        if (res.success) {
          _this.$alert("密码修改成功，请重新登录", {
            type: 'info'
          }).then(function () {
            _this.logout();
          }, function () {
            _this.logout();
          });
        } else {
          _this.$message.error({
            message: res.msg
          });
          _this.disabled = false;
        }
      });
    },
    logout: function () {
      var _logout = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return this.$store.dispatch('user/logout');
            case 1:
              this.$router.push("/login");
              window.location.reload();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};